import React from "react";
import { SlotTooltipData } from "./types";

interface IProps {
  data: SlotTooltipData;
}

const TimeSlotTooltip: React.FC<IProps> = ({ data }) => {
  return (
    <div className="time-slot-tooltip">
      {/* <div>
        <strong>Kort:</strong> {data.contextName}
      </div> */}
      <div>
        <strong>Godzina:</strong> {data.timeRange}
      </div>
      {data.duration !== undefined && (
        <div>
          <strong>Czas trwania:</strong> {data.duration}
        </div>
      )}
      <div>
        <strong>Status:</strong> {data.status}
      </div>
      {data.availablePlaces !== undefined && (
        <div>
          <strong>Dostępne miejsca:</strong> {data.availablePlaces}
        </div>
      )}
      {data.occupancy && (
        <div>
          <strong>Zajęte miejsca:</strong> {data.occupancy}
        </div>
      )}
    </div>
  );
};

export default TimeSlotTooltip;
